import { useQuery } from "@tanstack/react-query";

import { getMarkets } from "@web-app/api";

export const useOrderMarkets = (options?: {
  countryCode?: string;
  enabled?: boolean;
}) => {
  return useQuery({
    enabled: options?.enabled ?? true,
    queryFn: async () => {
      const response = await getMarkets(options?.countryCode);
      return response;
    },
    queryKey: ["order-states", options?.countryCode ?? "US"],
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });
};
